import React from 'react'

const GraphV2 = () => (
  <svg width="420px" height="200px" viewBox="0 0 420 200" version="1.1" xmlns="http://www.w3.org/2000/svg" style={{
    border:'var(--size-border-base) solid var(--color-border-secondary)', 
    margin: 'var(--size-padding-large) auto',
    display: 'block'}}>
      <g id="Artboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <text id="Traffic" fontFamily="IBMPlexSans-Bold, IBM Plex Sans" fontSize="20" fontWeight="bold" fill="var(--color-font-primary)">
          <tspan x="10.23" y="28">Traffic</tspan>
        </text>
        <text id="Last-updated-2-minut" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
          <tspan x="262.14" y="187">Last updated 2 minutes ago</tspan>
        </text>
        <text id="Page-hits-in-2019" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="16" fontWeight="normal" fill="var(--color-font-primary)">
          <tspan x="10.472" y="46">Page hits in 2019</tspan>
        </text>
        <text id="View-more" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="16" fontWeight="normal" fill="var(--color-font-link)">
          <tspan x="333" y="24">View more</tspan>
        </text>
        <g id="Group" transform="translate(10.000000, 63.000000)">
          <polyline id="Line" stroke="var(--color-core-green)" strokeWidth="2" strokeLinecap="square" points="37.5 48 69.8014915 21.9550781 102.102983 26.6669922 134.404474 34.9775391 166.705966 26.6669922 199.007457 34.9775391 231.308949 4.39453125 263.61044 31.1378485 295.911932 57.2949219 328.213423 34.9775391 360.514915 48 392.816406 41.28125"></polyline>
          <path d="M31,84.5 L402.576172,84.5" id="Line-2" stroke="var(--color-border-tertiary)" strokeLinecap="square"></path>
          <path d="M31,84.5 L31,0.69140625" id="Line-3" stroke="var(--color-border-tertiary)" strokeLinecap="square"></path>
          <text id="0" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="14.8" y="85">0</tspan>
          </text>
          <text id="100" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="0.4" y="51">100</tspan>
          </text>
          <text id="200" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="0.4" y="16">200</tspan>
          </text>
          <text id="Jan" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="31" y="100">Jan</tspan>
          </text>
          <text id="Feb" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="62" y="100">Feb</tspan>
          </text>
          <text id="Mar" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="94" y="100">Mar</tspan>
          </text>
          <text id="Apr" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="126" y="100">Apr</tspan>
          </text>
          <text id="May" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="157" y="100">May</tspan>
          </text>
          <text id="Jun" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="191" y="100">Jun</tspan>
          </text>
          <text id="Jul" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="223" y="100">Jul</tspan>
          </text>
          <text id="Aug" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="251" y="100">Aug</tspan>
          </text>
          <text id="Sep" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="283" y="100">Sep</tspan>
          </text>
          <text id="Oct" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="315" y="100">Oct</tspan>
          </text>
          <text id="Nov" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="346" y="100">Nov</tspan>
          </text>
          <text id="Dec" fontFamily="IBMPlexSans, IBM Plex Sans" fontSize="12" fontWeight="normal" fill="var(--color-font-tertiary)">
            <tspan x="379" y="100">Dec</tspan>
          </text>
        </g>
      </g>
  </svg>
);

export default GraphV2;